export const appTypes = [
    {label: 'Class', value: 'CLASS'},
    {label: 'Home', value: 'HOME'},
    {label: 'Class Online', value: 'CLASSONLINE'},
    {label: 'Home Online', value: 'HOMEONLINE'},
];
export const contentTypes = [
    {label: 'MCQ', value: 'MCQ'},
    {label: 'Open Ended', value: 'OPENENDED'},
    {label: 'Hybrid Exam', value: 'HYBRID'},
    {label: 'Other', value: 'OTHER'},
];
export const examStatuses = [
    { label: 'NOT READY', value: 'NOTREADY' },
    { label: 'OFFLINE', value: 'OFFLINE' },
    { label: 'ONLINE', value: 'ONLINE' },
    { label: 'ENDED', value: 'ENDED' },
    { label: 'COMPLETE', value: 'COMPLETE' },
];
export const testTypes = [
    {label: 'Exam', value: 'EXAM'},
    {label: 'Homework', value: 'HW'},
    {label: 'Project', value: 'PROJECT'},
    {label: 'Personality Test', value: 'PERS'},
];
export const scoringTypes = [
    {label: 'Single', value: 'SINGLE'},
    {label: 'Course Based', value: 'COURSE'},
    {label: 'Course Based With Total', value: 'COURSEWITHTOTAL'},
    {label: 'Section Based', value: 'SECTION'},
    {label: 'Section Based With Total', value: 'SECTIONWITHTOTAL'},
    {label: 'TYT', value: 'TYT'},
    {label: 'LGS', value: 'LGS'},
    {label: 'Custom', value: 'CUSTOM'},
];
export const scoringFuncts = [
    {label: 'Item Score', value: 'ITEMSCORE'},
    {label: 'T-Score', value: 'TSCORE'},
    {label: 'Z-Score', value: 'ZSCORE'},
    {label: 'Percentage', value: 'PERCENT'},
    {label: 'Max Score', value: 'MAXSCORE'},
    {label: 'Limit', value: 'LIMIT'},    
    {label: 'Weigted Sum', value: 'WEIGHTEDSUM'},    
];
export const groupTypes = [
    {label: 'Class', value: 'CLS'},
    {label: 'Program', value: 'PRG'},
    {label: 'Course', value: 'COURSE'},
    {label: 'Grade', value: 'GRADE'},
    {label: 'None', value: 'NONE'},
];
export const difficultyOptions = [
    {label: 'Very easy', value: 1},
    {label: 'Easy', value: 2},
    {label: 'Moderate', value: 3},
    {label: 'Hard', value: 4},
    {label: 'Very hard', value: 5},
];

export const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const examStatusesAll=[{label: 'ALL', value:'ALL'},...examStatuses];
export const appTypesAll=[{label: 'ALL', value:'ALL'},...appTypes];
export const testTypesAll=[{label: 'ALL', value:'ALL'},...testTypes];
